import { useQuery } from 'react-query'
import { getAttendanceGraph, getNetworkAttendanceGraph } from '../Reports/apis/api-reports'
import { useReports } from '../Context/ReportsContext'
import { useCohorts } from './useCohorts'

export const useAttendance = () => {
    const { reportQuery, enabled, staleTime, isNetworkContext, networkId } = useReports()
    const { courseId, cohorts, from, to } = reportQuery
    const { networkCohorts } = useCohorts()

    // Get courseIds from network cohorts if in network context
    // Filter by selected cohort dates from reportQuery
    // Note: reportQuery.cohorts has YYYY-MM-DD format, nc.startDate has ISO format
    // If cohorts is empty, use all available networkCohorts (initial state)
    const selectedCohortIds = isNetworkContext
        ? networkCohorts
            ?.filter((nc) =>
                cohorts?.length === 0 || cohorts?.includes(nc.startDate.substring(0, 10))
            )
            .map((c) => c.courseIdMongo) || []
        : []

    // Choose API based on context
    const fetchFunction = isNetworkContext
        ? () => getNetworkAttendanceGraph({ networkId: networkId as string, cohorts: selectedCohortIds, from, to })
        : () => getAttendanceGraph(reportQuery)

    // Build query key with explicit from/to values
    const queryKey = isNetworkContext
        ? [networkId, 'Network Reports', 'Attendances', 'Graph', `Cohorts: ${selectedCohortIds.join()}`, from, to]
        : [courseId, 'Reports', 'Attendances', 'Graph', `Cohorts: ${cohorts?.join()}`, from, to]

    const { data: attendances, ...rest } = useQuery(queryKey, fetchFunction, {
        enabled: isNetworkContext ? !!networkId && selectedCohortIds.length > 0 : enabled,
        staleTime: isNetworkContext ? 0 : staleTime, // No cache for network context to allow immediate refetch
    })

    return { attendances, ...rest }
}
